import types from "../index";

function setStep(step) {
    return {
        type: types.REGISTRATION_STEPS_SET_STEP,
        step,
    }
}

function selectSubscription(selectedSubscription) {
    return {
        type: types.REGISTRATION_STEPS_SELECT_SUBSCRIPTION,
        selectedSubscription,
    }
}

function loadUser(user) {
    return {
        type: types.REGISTRATION_STEPS_LOAD_USER,
        user,
    }
}

function setEmailVerified(status) {
    return {
        type: types.REGISTRATION_STEPS_SET_EMAIL_VERIFIED,
        status,
    }
}

function setRegistrationError(message) {
    return {
        type: types.REGISTRATION_STEPS_SET_REGISTRATION_ERROR,
        message,
    }
}

function setAmount(amount) {
    return {
        type: types.REGISTRATION_STEPS_SET_AMOUNT,
        amount
    }
}

const actions = {
    setStep,
    selectSubscription,
    loadUser,
    setEmailVerified,
    setRegistrationError,
    setAmount,
}

export default actions;
